/* tslint:disable */
/* eslint-disable */
// this is an auto generated file. This will be overwritten

import * as APITypes from "./API";
type GeneratedMutation<InputType, OutputType> = string & {
  __generatedMutationInput: InputType;
  __generatedMutationOutput: OutputType;
};

export const createMessages = /* GraphQL */ `mutation CreateMessages($input: MessagesInput) {
  createMessages(input: $input) {
    messageId
    message
    presentationId
    senderEmail
    senderName
    sentDate
    state
    lastChanges
    presentationTitle
    prioritizeIndex
    senderStatus
    aiResponse
    topic
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateMessagesMutationVariables,
  APITypes.CreateMessagesMutation
>;
export const updateMessages = /* GraphQL */ `mutation UpdateMessages($input: MessagesInput) {
  updateMessages(input: $input) {
    messageId
    message
    presentationId
    senderEmail
    senderName
    sentDate
    state
    lastChanges
    presentationTitle
    prioritizeIndex
    senderStatus
    aiResponse
    topic
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateMessagesMutationVariables,
  APITypes.UpdateMessagesMutation
>;
export const deleteMessages = /* GraphQL */ `mutation DeleteMessages($messageId: String!) {
  deleteMessages(messageId: $messageId) {
    messageId
    message
    presentationId
    senderEmail
    senderName
    sentDate
    state
    lastChanges
    presentationTitle
    prioritizeIndex
    senderStatus
    aiResponse
    topic
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteMessagesMutationVariables,
  APITypes.DeleteMessagesMutation
>;
export const updateBatchMessages = /* GraphQL */ `mutation UpdateBatchMessages(
  $presentationId: String!
  $input: [MessagesInput]
) {
  updateBatchMessages(presentationId: $presentationId, input: $input) {
    items {
      messageId
      message
      presentationId
      senderEmail
      senderName
      sentDate
      state
      lastChanges
      presentationTitle
      prioritizeIndex
      senderStatus
      aiResponse
      topic
      __typename
    }
    presentationId
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateBatchMessagesMutationVariables,
  APITypes.UpdateBatchMessagesMutation
>;
export const createInterfaceSettings = /* GraphQL */ `mutation CreateInterfaceSettings($input: InterfaceSettingsInput) {
  createInterfaceSettings(input: $input) {
    presentationId
    reviewMode
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateInterfaceSettingsMutationVariables,
  APITypes.CreateInterfaceSettingsMutation
>;
export const updateInterfaceSettings = /* GraphQL */ `mutation UpdateInterfaceSettings($input: InterfaceSettingsInput) {
  updateInterfaceSettings(input: $input) {
    presentationId
    reviewMode
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateInterfaceSettingsMutationVariables,
  APITypes.UpdateInterfaceSettingsMutation
>;
export const createChatMessages = /* GraphQL */ `mutation CreateChatMessages($input: ChatMessagesInput!) {
  createChatMessages(input: $input) {
    chatMessageId
    presentationId
    senderName
    createdAt
    message
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateChatMessagesMutationVariables,
  APITypes.CreateChatMessagesMutation
>;
export const commandsMutation = /* GraphQL */ `mutation CommandsMutation($input: CommandsInput) {
  commandsMutation(input: $input) {
    backup_stream
    backup_stream_time
    content
    stream_time
    type
    concurrencyUserId
    currentSlideIndex
    presentationId
    userName
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CommandsMutationMutationVariables,
  APITypes.CommandsMutationMutation
>;
export const updatePoll = /* GraphQL */ `mutation UpdatePoll($poll: PollInput, $presentationId: String!) {
  updatePoll(poll: $poll, presentationId: $presentationId) {
    pollId
    presentationId
    hideForPresenter
    order
    status
    type
    value
    publicAdjustment
    poll_in_progress_timestamp
    poll_completed_timestamp
    countVotes
    result_slide_added
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdatePollMutationVariables,
  APITypes.UpdatePollMutation
>;
export const createPoll = /* GraphQL */ `mutation CreatePoll(
  $poll: PollInput
  $pollChoices: [PollChoicesInput]
  $presentationId: String!
) {
  createPoll(
    poll: $poll
    pollChoices: $pollChoices
    presentationId: $presentationId
  ) {
    presentationId
    Polls {
      pollId
      presentationId
      hideForPresenter
      order
      status
      type
      value
      publicAdjustment
      poll_in_progress_timestamp
      poll_completed_timestamp
      countVotes
      result_slide_added
      __typename
    }
    PollChoices {
      pollId
      pollChoiceId
      isCustomResponse
      order
      value
      status
      count
      __typename
    }
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreatePollMutationVariables,
  APITypes.CreatePollMutation
>;
export const deletePoll = /* GraphQL */ `mutation DeletePoll($pollId: String!, $presentationId: String!) {
  deletePoll(pollId: $pollId, presentationId: $presentationId) {
    presentationId
    Polls {
      pollId
      presentationId
      hideForPresenter
      order
      status
      type
      value
      publicAdjustment
      poll_in_progress_timestamp
      poll_completed_timestamp
      countVotes
      result_slide_added
      __typename
    }
    PollChoices {
      pollId
      pollChoiceId
      isCustomResponse
      order
      value
      status
      count
      __typename
    }
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeletePollMutationVariables,
  APITypes.DeletePollMutation
>;
export const updatePollAndPollChoices = /* GraphQL */ `mutation UpdatePollAndPollChoices(
  $poll: PollInput
  $pollChoices: [PollChoicesInput]
  $presentationId: String!
) {
  updatePollAndPollChoices(
    poll: $poll
    pollChoices: $pollChoices
    presentationId: $presentationId
  ) {
    presentationId
    Polls {
      pollId
      presentationId
      hideForPresenter
      order
      status
      type
      value
      publicAdjustment
      poll_in_progress_timestamp
      poll_completed_timestamp
      countVotes
      result_slide_added
      __typename
    }
    PollChoices {
      pollId
      pollChoiceId
      isCustomResponse
      order
      value
      status
      count
      __typename
    }
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdatePollAndPollChoicesMutationVariables,
  APITypes.UpdatePollAndPollChoicesMutation
>;
export const pollCommand = /* GraphQL */ `mutation PollCommand(
  $poll: PollInput!
  $presentationId: String!
  $livePresentationId: String!
  $pollCommand: PollCommand!
) {
  pollCommand(
    poll: $poll
    presentationId: $presentationId
    livePresentationId: $livePresentationId
    pollCommand: $pollCommand
  ) {
    backup_stream
    backup_stream_time
    content
    stream_time
    type
    livePresentationId
    presentationId
    __typename
  }
}
` as GeneratedMutation<
  APITypes.PollCommandMutationVariables,
  APITypes.PollCommandMutation
>;
export const commandAjustment = /* GraphQL */ `mutation CommandAjustment($input: CommandAdjustmentInput) {
  commandAjustment(input: $input) {
    backup_stream_time
    stream_time
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CommandAjustmentMutationVariables,
  APITypes.CommandAjustmentMutation
>;
export const publishCommand = /* GraphQL */ `mutation PublishCommand($input: PublishCommandInput) {
  publishCommand(input: $input) {
    livePresentationId
    idHash
    presentationLink
    liveCommand {
      type
      backup_stream
      backup_stream_time
      stream_time
      __typename
    }
    __typename
  }
}
` as GeneratedMutation<
  APITypes.PublishCommandMutationVariables,
  APITypes.PublishCommandMutation
>;
export const knovioCommand = /* GraphQL */ `mutation KnovioCommand($input: KnovioCommandInput) {
  knovioCommand(input: $input) {
    backup_stream
    backup_stream_time
    content
    stream_time
    type
    livePresentationId
    presentationId
    __typename
  }
}
` as GeneratedMutation<
  APITypes.KnovioCommandMutationVariables,
  APITypes.KnovioCommandMutation
>;
export const startMediaLiveChannel = /* GraphQL */ `mutation StartMediaLiveChannel($input: StartMediaLiveChannelInput) {
  startMediaLiveChannel(input: $input) {
    account_id
    channel_info {
      inputReceivedDate
      isSynced
      processingPipeline
      __typename
    }
    created_by_user
    created_date
    hls_link
    id
    live_stream_provider
    modified_by_user
    modified_date
    name
    presentation_id
    profile
    rtmp_input_id
    rtmp_link
    start_date
    state
    sync_flow
    unique_identifier
    __typename
  }
}
` as GeneratedMutation<
  APITypes.StartMediaLiveChannelMutationVariables,
  APITypes.StartMediaLiveChannelMutation
>;
export const addMediaLiveChannel = /* GraphQL */ `mutation AddMediaLiveChannel($input: AddMediaLiveChannelInput) {
  addMediaLiveChannel(input: $input) {
    account_id
    channel_info {
      inputReceivedDate
      isSynced
      processingPipeline
      __typename
    }
    created_by_user
    created_date
    hls_link
    id
    live_stream_provider
    modified_by_user
    modified_date
    name
    presentation_id
    profile
    rtmp_input_id
    rtmp_link
    start_date
    state
    sync_flow
    unique_identifier
    __typename
  }
}
` as GeneratedMutation<
  APITypes.AddMediaLiveChannelMutationVariables,
  APITypes.AddMediaLiveChannelMutation
>;
export const savePollVotes = /* GraphQL */ `mutation SavePollVotes(
  $presentationId: String!
  $pollId: String!
  $uniqueViewerId: String!
  $pollChoiceIds: [PollChoiceIdInput]
) {
  savePollVotes(
    presentationId: $presentationId
    pollId: $pollId
    uniqueViewerId: $uniqueViewerId
    pollChoiceIds: $pollChoiceIds
  ) {
    pollVotesCount {
      pollChoiceId
      count
      __typename
    }
    allVotesCount
    presentationId
    pollId
    __typename
  }
}
` as GeneratedMutation<
  APITypes.SavePollVotesMutationVariables,
  APITypes.SavePollVotesMutation
>;
export const publishSegments = /* GraphQL */ `mutation PublishSegments(
  $input: PublishSegmentsInput!
  $presentationId: String!
) {
  publishSegments(input: $input, presentationId: $presentationId) {
    segments
    action
    atIndex
    presentationId
    __typename
  }
}
` as GeneratedMutation<
  APITypes.PublishSegmentsMutationVariables,
  APITypes.PublishSegmentsMutation
>;
export const publishSegmentsPresenter = /* GraphQL */ `mutation PublishSegmentsPresenter(
  $input: PublishSegmentsInput!
  $presentationId: String!
) {
  publishSegmentsPresenter(input: $input, presentationId: $presentationId) {
    segments
    action
    atIndex
    presentationId
    __typename
  }
}
` as GeneratedMutation<
  APITypes.PublishSegmentsPresenterMutationVariables,
  APITypes.PublishSegmentsPresenterMutation
>;
